export function deepFreeze(root) {
    const occurrences = new WeakSet();
    function freeze(value) {
        if (occurrences.has(value)) {
            return;
        }
        occurrences.add(value);
        for (const key of Reflect.ownKeys(value)) {
            const descriptor = Reflect.getOwnPropertyDescriptor(value, key);
            if (descriptor !== undefined &&
                'value' in descriptor &&
                isObjectLike(descriptor.value)) {
                freeze(descriptor.value);
            }
        }
        Object.freeze(value);
    }
    freeze(root);
    return root;
}
function isObjectLike(value) {
    return (typeof value === 'object' && value !== null) || typeof value === 'function';
}
